export function defaultCmp(a, b) {
	if (a < b) {
		return -1;
	} else if (a > b) {
		return 1;
	} else {
		return 0;
	}
}

export function cmpByKey(getKey, cmp = defaultCmp) {
	function cmpByKeyInner(a, b) {
		return cmp(getKey(a), getKey(b));
	}
	return cmpByKeyInner;
}
